"use client"
import {
  NativeTable
} from "./chunk-5KYTUYJO.mjs";

// src/components/table.ts
import { mergeMultiStyle } from "@yamada-ui/core";
var Table = mergeMultiStyle(
  NativeTable,
  {
    baseStyle: {
      sortIcon: {},
      td: {
        outline: "none",
        transitionDuration: "normal",
        transitionProperty: "common",
        _focusVisible: {
          boxShadow: "inline"
        }
      },
      th: {
        outline: "none",
        transitionDuration: "normal",
        transitionProperty: "common",
        _focusVisible: {
          boxShadow: "inline"
        }
      }
    },
    sizes: {
      sm: {
        sortIcon: {
          right: 2
        }
      },
      md: {
        sortIcon: {
          right: 3
        }
      },
      lg: {
        sortIcon: {
          right: 4
        }
      },
      xl: {
        sortIcon: {
          right: 6
        }
      }
    }
  }
)();

export {
  Table
};
//# sourceMappingURL=chunk-CFQULO2Q.mjs.map